import {Observable} from 'rxjs/Observable';

// Classes.
import {ViewData} from './view-data';
import {RankingItem} from '../fetching/types/ranking.item';
import {ResponseData} from '../fetching/wa-response/wa-api-response';

// Providers.
import {LoggerService} from '../logger/logger-service';
import {DataFetchService} from '../wa-services/data-fetch-service';
import {DatabaseService} from '../wa-services/database-service';
import {FactoryService} from '../wa-services/factory-service';
import {WaHelperService} from '../wa-services/wa-helper-service';

// Interfaces.
import {LocatorInterface} from '../interfaces/locator.interface';
import {ViewDataConfigStruct} from '../interfaces/view-data.interface';

export class WorldRankingListVD extends ViewData<RankingItem> {

  constructor(
    protected logger: LoggerService,
    protected fetchSrvc: DataFetchService,
    protected db: DatabaseService,
    protected factory: FactoryService,
    protected _helper: WaHelperService,
    protected _locator: LocatorInterface
  ) {
    super(logger, db, _locator);
  }

  public configureView() {
    let viewDataConf = new ViewDataConfigStruct();
    viewDataConf.maxAge = 900;
    this.applyConfiguration(viewDataConf);
  }

  public updateData(): Observable<ResponseData> {
    return this.fetchSrvc.requestWorldRanking(this.locator, this.pageInfo());
  }

  public mapItem(rawItem: any): RankingItem {
    return this.factory.newRankingItem(rawItem);
  }
}
